import { render, staticRenderFns } from "./followUpPeople.vue?vue&type=template&id=6d191170&scoped=true&"
import script from "./followUpPeople.vue?vue&type=script&lang=js&"
export * from "./followUpPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d191170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d191170')) {
      api.createRecord('6d191170', component.options)
    } else {
      api.reload('6d191170', component.options)
    }
    module.hot.accept("./followUpPeople.vue?vue&type=template&id=6d191170&scoped=true&", function () {
      api.rerender('6d191170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/list/followUpPeople.vue"
export default component.exports